const h = {
  "highlight-box": "highlight-box",
  "highlight-box--transparent": "highlight-box--transparent",
  "highlight-box--theme-aware": "highlight-box--theme-aware",
  "highlight-box--neutral": "highlight-box--neutral",
  "highlight-box--neutral-100": "highlight-box--neutral-100",
  "highlight-box--neutral-200": "highlight-box--neutral-200",
  "highlight-box--grey": "highlight-box--grey",
  "highlight-box--grey-50": "highlight-box--grey-50",
  "highlight-box--grey-100": "highlight-box--grey-100",
  "highlight-box--grey-200": "highlight-box--grey-200",
  "highlight-box--grey-300": "highlight-box--grey-300",
  "highlight-box--white": "highlight-box--white"
};
export {
  h as default
};
